import script from "./SupportStatusScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportStatusScreen.vue?vue&type=script&setup=true&lang=js"

import "./SupportStatusScreen.vue?vue&type=style&index=0&id=ea5dbbfc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea5dbbfc"]])

export default __exports__